import Select, {components} from 'react-select';
import {forwardRef, memo} from 'react';

const {Option, SingleValue} = components;

const componentOverrides = {
    Option: PaymentMethodOption,
    SingleValue: PaymentMethodSelection,
};

export const PaymentMethodsSelect = memo(forwardRef((props, ref) => {
    const finalProps = {
        ...props,
        menuPlacement: props.menuPlacement || 'auto', // Default value "bottom" is not working properly in invoice draft view (body is not being extended downwards when the menu collides with body bottom)
    }

    return <Select ref={ref} {...finalProps} components={componentOverrides}/>
}));
PaymentMethodsSelect.displayName = 'PaymentMethodsSelect';

function PaymentMethodOption(props) {
    return <Option {...props}>
        <PaymentMethodValue data={props.data}/>
    </Option>;
}

function PaymentMethodSelection(props) {
    return <SingleValue {...props}>
        <PaymentMethodValue data={props.data}/>
    </SingleValue>;
}

const PaymentMethodValue = memo((props) => {
    return <div className={'flex items-center gap-1'}>
        {props.data.icon ? <div style={{width: '40px'}}><img className="icon" src={props.data.icon} height={18} alt={'Payment method icon'}/></div> : null}
        {props.data.label}
    </div>;
});
PaymentMethodValue.displayName = 'PaymentMethodValue';
